import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';
import Lottie from 'react-lottie';
import animationData from '../../public/lotties/VW-Animation-evee.json';

type LottieButtonChatCTAProps = {
  onClick?: () => void;
  isDisabled?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  width?: number;
  height?: number;
};

export default function LottieButtonChatCTA({
  onClick,
  isDisabled,
  onMouseEnter,
  onMouseLeave,
  width = 64,
  height = 64,
}: LottieButtonChatCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [buttonRef, inView] = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    // If the button is in view, set isVisible to true
    if (inView) {
      setIsVisible(true);
    }
  }, [inView]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  return (
    <button
      ref={buttonRef}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        border: 'none',
        cursor: 'pointer',
        opacity: isVisible ? (isDisabled ? '0.5' : 1) : 0,
        transition: 'opacity 750ms ease-in-out',
        background: 'transparent',
        transform: 'scale(0.85)',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Lottie options={defaultOptions} height={height} width={width} />
    </button>
  );
}
